import React from 'react'
import { Stack, Typography } from '@mui/material'

const ChartEmptyStateOverlay: React.FC = () => {
    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
                pointerEvents: 'none'
            }}
        >
            <Stack alignItems="center" gap={2}>
                <svg
                    width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    fill="currentcolor"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M32 20C38.6274 20 44 24.4772 44 30C44 35.5228 38.6274 40 32 40C25.3726 40 20 35.5228 20 30C20 24.4772 25.3726 20 32 20Z"
                        stroke="currentcolor"
                        strokeWidth="2"
                        fill="none"
                    />
                    <ellipse
                        cx="32"
                        cy="30"
                        rx="16"
                        ry="6"
                        stroke="currentcolor"
                        strokeWidth="2"
                        fill="none"
                    />
                    <circle cx="28" cy="28" r="1.5" fill="currentcolor" />
                    <circle cx="36" cy="28" r="1.5" fill="currentcolor" />
                    <path
                        d="M16 36L20 40"
                        stroke="currentcolor"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M48 36L44 40"
                        stroke="currentcolor"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M32 44L32 48"
                        stroke="currentcolor"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M28 42C28 42 30 44 32 44C34 44 36 42 36 42"
                        stroke="currentcolor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        fill="white"
                    />
                </svg>

                <Stack alignItems="center" gap={1}>
                    <Typography
                        variant="h6"
                        textAlign="center"
                        sx={{ fontWeight: 500 }}
                    >
                        No data here
                    </Typography>
                    <Typography
                        variant="body2"
                        textAlign="center"
                        sx={{ maxWidth: 280, lineHeight: 1.5 }}
                    >
                        Hope, it'll appear on the chart soon.
                    </Typography>
                </Stack>
            </Stack>
        </div>
    )
}

export default ChartEmptyStateOverlay